// Single value filters of the feed, like the app: game, mode, weapon.
// The mode and the weapon depend on the game: they are reset when the game changes.

// 42 is the value of "∞" (more than 6 kills).
const KILLS_INFINITE = 42;

const STORAGE_KEY = 'feedFilters';

interface FeedFilters {
  gameName: string;
  mode: string;
  weapon: string;
}

const EMPTY_FEED_FILTERS: FeedFilters = {
  gameName: '',
  mode: '',
  weapon: '',
};

const countFeedFilters = (filters: FeedFilters) => (
  [filters.gameName, filters.mode, filters.weapon].filter(Boolean).length
);

// Fields of VideoV2PaginationInput, only the chosen ones.
const getFeedFiltersInput = (filters: FeedFilters) => {
  const input = {} as { [key: string]: string };
  if (filters.gameName) {
    input.gameName = filters.gameName;
  }
  if (filters.mode) {
    input.mode = filters.mode;
  }
  if (filters.weapon) {
    input.weapon = filters.weapon;
  }
  return input;
};

// Saved in the browser: the feed opens with the filters of the last visit.
const loadFeedFilters = (): FeedFilters => {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (saved && typeof saved.gameName === 'string') {
      return {
        gameName: saved.gameName,
        mode: saved.mode || '',
        weapon: saved.weapon || '',
      };
    }
  } catch (e) {
    // Blocked or broken storage: no saved filters.
  }
  return EMPTY_FEED_FILTERS;
};

const saveFeedFilters = (filters: FeedFilters) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
  } catch (e) {
    // Blocked storage: the filters are only kept for this visit.
  }
};

export type { FeedFilters };

export {
  countFeedFilters,
  EMPTY_FEED_FILTERS,
  getFeedFiltersInput,
  KILLS_INFINITE,
  loadFeedFilters,
  saveFeedFilters,
};
